/*
Copyright 2025 Adobe. All rights reserved.
This file is licensed to you under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License. You may obtain a copy
of the License at http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software distributed under
the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
OF ANY KIND, either express or implied. See the License for the specific language
governing permissions and limitations under the License.
*/

import { tag as html, TemplateResult } from '../custom-tag.js';

export { setCustomTemplateLiteralTag } from '../custom-tag.js';
export const GridsAndRulersIcon = ({
  width = 24,
  height = 24,
  hidden = false,
  title = 'Grids And Rulers',
} = {}): string | TemplateResult => {
  return html`<svg
    xmlns="http://www.w3.org/2000/svg"
    width="${width}"
    height="${height}"
    viewBox="0 0 20 20"
    aria-hidden=${hidden ? 'true' : 'false'}
    role="img"
    fill="currentColor"
    aria-label="${title}"
  >
    <path
      fill="currentColor"
      d="m2.75,12.05859c-.41406,0-.75-.33594-.75-.75v-7.05859c0-1.24023,1.00928-2.25,2.25-2.25h8.5c1.24072,0,2.25,1.00977,2.25,2.25v3.14844c0,.41406-.33594.75-.75.75s-.75-.33594-.75-.75v-3.14844c0-.41309-.33643-.75-.75-.75H4.25c-.41357,0-.75.33691-.75.75v7.05859c0,.41406-.33594.75-.75.75Z"
    />
    <path
      fill="currentColor"
      opacity="0.3"
      d="m6,11.26953l5-1.69189v-2.32764h3v-1.25h-3v-3h-1.25v3h-2.5v-3h-1.25v3h-3v1.25h3v2.5h-3v1.25h3v.26953Zm1.25-4.01953h2.5v2.5h-2.5v-2.5Z"
    />
    <path
      fill="currentColor"
      d="m18.9209,12.69238l-.88037-2.59473c-.26611-.78223-1.1167-1.20703-1.90137-.93848L3.35254,13.48438c-.37988.12793-.68701.39551-.86523.75488-.17773.35938-.20508.7666-.07666,1.14746l.87988,2.59375c.21143.625.79639,1.01953,1.42188,1.01953.15918,0,.32129-.02539.47998-.0791l12.78809-4.3252c0-.00098.00049-.00098.00049-.00098.78223-.26465,1.2041-1.11719.93994-1.90234Zm-14.20947,4.80664l-.87988-2.59277,1.57623-.5332.40765,1.20605c.08838.26074.33154.4248.59229.4248.06641,0,.13379-.01074.2002-.0332.32715-.11035.50244-.46484.3916-.79199l-.40802-1.20605,1.65778-.56104.21069.62354c.08838.26074.33154.4248.59229.4248.06641,0,.13379-.01074.2002-.0332.32715-.11035.50244-.46484.39209-.79199l-.21075-.62378,1.65765-.56079.40759,1.20605c.08838.26074.33154.4248.59229.4248.06641,0,.13379-.01074.2002-.0332.32715-.11035.50244-.46484.3916-.79199l-.40796-1.20605,1.6582-.56104.21118.62354c.08789.26074.33105.4248.5918.4248.06641,0,.13428-.01074.20068-.0332.32666-.11035.50195-.46582.39111-.79199l-.21118-.62354,1.50269-.5083.87939,2.59473-12.7876,4.32422Z"
    />
  </svg>`;
};
